import React from "react";

import AddClaimPage from "../claim/AddClaimPage";
import withDonation from "./withDonation";
import withClaimContainer from "../claim/withClaimContainer";

export default withClaimContainer(withDonation(AddClaimPage));



// WEBPACK FOOTER //
// ./components/donations/DonationSubmitPage.js